import React, { useContext } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import EditIcon from 'components/Icons/EditIcon';
import GenericList from 'components/List/GenericList';
import { EntityColumnType } from 'components/List/TableCellWithConfigurableStyle';
import { useClientsWithFilter } from 'hooks';
import { Routes } from 'routes';
import { TableFilterContext } from 'tableFilterContext';
import ActionButton from 'components/Buttons/ActionButton';

const columns = [
  {
    columnPath: '',
    headerTranslationKey: 'clients.action',
    type: 'action' as EntityColumnType,
    disableSort: true,
    style: {
      columnWidth: '5%',
    },
  },
  {
    columnPath: 'shortName',
    headerTranslationKey: 'clients.client',
    style: {
      columnWidth: '25%',
      textAlign: 'center',
    },
  },
  {
    columnPath: 'code',
    headerTranslationKey: 'clients.code',
    style: {
      columnWidth: '25%',
      textAlign: 'center',
    },
  },
  {
    columnPath: 'postalCode',
    headerTranslationKey: 'clients.postalCode',
    type: 'number' as EntityColumnType,
    style: {
      columnWidth: '35%',
      paddingLeft: '3rem',
      textAlign: 'center',
    },
  },
  {
    columnPath: 'city',
    headerTranslationKey: 'clients.cityName',
    disableSort: true,
    style: {
      columnWidth: '30%',
      textAlign: 'center',
    },
  },
];

const ClientList: React.FC = () => {
  const { page, itemsPerPage, order, orderBy } = useContext(TableFilterContext);
  const [clientList, total] = useClientsWithFilter({ page, itemsPerPage }, { order, orderBy });
  const { t } = useTranslation();

  return (
    <GenericList
      entities={clientList}
      columns={columns}
      total={total}
      detailsLink={Routes.Clients}
      biggerSideMargins
      generateAvailableActions={({ id }) => {
        const disabled = true;
        const linkTo = { pathname: `/`, state: { referer: '' } };

        return [
          {
            title: t('update'),
            onClick: () => {},
            disabled,
            action: (
              <ActionButton
                variant="outlined"
                icon={EditIcon}
                component={Link}
                data-qa-id={'edit-button'}
                to={linkTo}
                disabled={disabled}
              />
            ),
          },
          {
            title: t('delete'),
            onClick: () => {},
            disabled,
            action: (
              <ActionButton
                variant="outlined"
                icon={DeleteIcon}
                data-qa-id={'delete-button'}
                onClick={() => {}}
                disabled={disabled}
              />
            ),
          },
        ];
      }}
    />
  );
};
export default ClientList;
